import React, { createContext, useContext, useState, useRef, useCallback, ReactNode } from 'react';

interface LoadingContextProps {
  loading: boolean;
  setLoading: (isLoading: boolean, minTime?: number) => void;
}

const LoadingContext = createContext<LoadingContextProps | undefined>(undefined);

export const LoadingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [loading, setLoadingState] = useState(false);
  const loadingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const setLoading = useCallback((isLoading: boolean, minTime = 800) => {
    if (isLoading) {
      // Cancella eventuali timeout pendenti prima di attivare il nuovo loading
      if (loadingTimeoutRef.current) {
        clearTimeout(loadingTimeoutRef.current);
        loadingTimeoutRef.current = null;
      }
      setLoadingState(true); // Attiva immediatamente il caricamento
    } else {
      if (loadingTimeoutRef.current) clearTimeout(loadingTimeoutRef.current); // Cancella eventuali timeout attivi

      const timeout = setTimeout(() => {
        setLoadingState(false); // Chiude il caricamento dopo il tempo minimo
      }, minTime);

      loadingTimeoutRef.current = timeout;
    }
  }, []);

  return <LoadingContext.Provider value={{ loading, setLoading }}>{children}</LoadingContext.Provider>;
};

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};
